import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  EntityLifecycleFilter,
  EntityNamespaceFilter,
  EntityTagFilter,
} from '@backstage/plugin-catalog-react';
import { CatalogFilterBlueprint } from '@backstage/plugin-catalog-react/alpha';

/**
 * The catalog index page's filters, drawn with Backstage UI instead of
 * catalog-react's MUI pickers. Same extension names as the catalog plugin's
 * own (`catalog-filter:catalog/<name>`), so these replace them in place; the
 * page around them — the filter column, the table — is still the plugin's.
 *
 * The upstream extensions' config (`initialFilter` of kind and list, `mode`
 * of the owner filter) is not carried over: nothing here set it.
 */
const load = () => import('./Filters');

export const catalogFiltersModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    CatalogFilterBlueprint.make({
      name: 'kind',
      params: {
        loader: async () => {
          const { KindFilter } = await load();
          return <KindFilter />;
        },
      },
    }),
    CatalogFilterBlueprint.make({
      name: 'type',
      params: {
        loader: async () => {
          const { TypeFilter } = await load();
          return <TypeFilter />;
        },
      },
    }),
    CatalogFilterBlueprint.make({
      name: 'list',
      params: {
        loader: async () => {
          const { ListFilter } = await load();
          return <ListFilter />;
        },
      },
    }),
    CatalogFilterBlueprint.make({
      name: 'mode',
      params: {
        loader: async () => {
          const { OwnerFilter } = await load();
          return <OwnerFilter />;
        },
      },
    }),
    CatalogFilterBlueprint.make({
      name: 'lifecycle',
      params: {
        loader: async () => {
          const { FacetFilter } = await load();
          return (
            <FacetFilter
              title="entityLifecyclePicker.title"
              name="lifecycles"
              path="spec.lifecycle"
              Filter={EntityLifecycleFilter}
            />
          );
        },
      },
    }),
    CatalogFilterBlueprint.make({
      name: 'tag',
      params: {
        loader: async () => {
          const { FacetFilter } = await load();
          return (
            <FacetFilter
              title="entityTagPicker.title"
              name="tags"
              path="metadata.tags"
              Filter={EntityTagFilter}
              searchable
            />
          );
        },
      },
    }),
    CatalogFilterBlueprint.make({
      name: 'processing-status',
      params: {
        loader: async () => {
          const { ProcessingStatusFilter } = await load();
          return <ProcessingStatusFilter />;
        },
      },
    }),
    CatalogFilterBlueprint.make({
      name: 'namespace',
      params: {
        loader: async () => {
          const { FacetFilter } = await load();
          return (
            <FacetFilter
              title="entityNamespacePicker.title"
              name="namespace"
              path="metadata.namespace"
              Filter={EntityNamespaceFilter}
            />
          );
        },
      },
    }),
  ],
});
